<div class="wrapper" *ngIf="!userHasNoAccess">
    <CDMS-Portal-U2-main-sidenav
    [parentScreens]="parentScreens"
    [class.side-nav-collapsed]="sideNavCollapse">
    </CDMS-Portal-U2-main-sidenav>
    <div class="content">
        <CDMS-Portal-U2-main-breadcrumb></CDMS-Portal-U2-main-breadcrumb>
        <div class="page-content roles-content mb-0" [class.side-nav-collapsed]="sideNavCollapse">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>
